import { OperationConstant } from '@/common/Constants';

export default {
  data() {
    return {
      currentRow: {},
      // 需要操作保护的动作
      actionType: '',
      // 操作保护弹框是否可见
      operationProtectVisible: false,
      // 当前操作物理机类型：vpc/basic
      instanceType: '',
      clientToken: Normal.getClientToken(),
      // list 或者 detail
      pageType: ''
    };
  },
  methods: {
    // 开启操作保护弹框
    openOperationProtect(actionType, params, type) {
      // 重装系统 增加按钮加载状态
      if(actionType === OperationConstant.REINSTALL) {
          this.sureLoading = true
      }
      // 显示操作保护弹框
      this.operationProtectVisible = true;
      this.actionType = actionType;
      this.pageType = type;
      this.currentRow = params;
    },
    /**
     **@disc: 根据不同的操作保护动作类型，调用不同的操作接口
     **@params: headers, this.instanceType: 是来自basic或者vpc
     */
    differentOperationProjectAction(headers) {
        switch (this.actionType) {
            case OperationConstant.REINSTALL: {
              this.systemReinstallTwiceConfirm(headers);
              break;
            }
            case OperationConstant.RESTART: {
                if (this.currentRow.instanceType === "game") {
                    this.restartInstance(headers)
                } else {
                    this.restartCpsInstance(headers);
                }
              break;
            }
            case OperationConstant.STOP: {
                if (this.currentRow.instanceType === "game") {
                    this.closeInstance(headers)
                } else {
                    this.stopInstance(headers);
                }
              break;
            }
            case OperationConstant.DELETE: {
              this.deleteInstance(headers);
              break;
            }
            case OperationConstant.DELETE_EIP: {
              this.deleteEip(headers);
              break;
            }
            case OperationConstant.DELETE_SLB: {
              this.deleteSlb(headers);
              break;
            }
            case OperationConstant.DELETE_IPV6: {
              this.deleteIpv6(headers);
              break;
            }
            case OperationConstant.DELETE_CERT: {
              this.deleteCert(headers);
              break;
            }
            case OperationConstant.BATCH_DELETE: {
              this.deleteBatch(headers);
              break;
            }
            case OperationConstant.BATCH_STOP: {
              this.stopBatch(headers);
              break;
            }
            case OperationConstant.BATCH_RESTART: {
              this.restartBatch(headers);
              break;
            }
            case OperationConstant.DELETE_NAT: {
              this.deleteNat(headers);
              break;
            }
            case OperationConstant.DELETE_SBW: {
              this.deleteSbw(headers);
              break;
            }
        }
    },

    // 重启物理机
    restartCpsInstance(headers) {
      const params = {
        instanceId: this.currentRow.instanceId,
        region: this.currentRow.region,
        clientToken: this.clientToken
      };
      Ajax.put('/api/cps/restartInstance', params, { headers })
        .then(() => {
          if (this.pageType === 'list') {
            if (this.instanceType === 'basic') {
              this.updateList('refresh');
            } else {
              this.refreshList({});
            }
          } else if (this.pageType === 'detail') {
            if (this.instanceType === 'basic') {
              this.refreshData();
            } else {
              this.operateRefresh();
            }
          }
        })
        .catch(() => {
        });
    },
    // 关闭物理机
    stopInstance(headers, type) {
      const params = {
        instanceId: this.currentRow.instanceId,
        region: this.currentRow.region,
        clientToken: this.clientToken
      };
      Ajax.put('api/cps/stopInstance', params, { headers })
        .then(() => {
          if (this.pageType === 'list') {
            if (this.instanceType === 'basic') {
              this.updateList('refresh');
            } else {
              this.refreshList({});
            }
          } else if (this.pageType === 'detail') {
            if (this.instanceType === 'basic') {
              this.refreshData();
            } else {
              this.operateRefresh();
            }
          }
        });
    },
    onSuccess(token) {
      console.log('onSuccess token is', token);
      // 关闭操作保护弹框
      this.operationProtectVisible = false;
      const headers = {
        'x-jdcloud-security-token': token
      };
      this.differentOperationProjectAction(headers, this.instanceType);
    },
    onError(error, opt) {
      console.log('onError is ', error);
      if (opt && opt.notOPOperation) {
        // 未开启操作保护，执行正常操作
        this.differentOperationProjectAction();
      } else {
        this.$message.error(error.message || '网络错误');
      }
    },
  }
};



// WEBPACK FOOTER //
// ./src/mixins/operationProject.js